<template>
  <div :id="`user-profile-${userId}`">
    <dash-header :pages="breadCrumbsPages" :dashboardTitle="'User Profile'" />
    <a-layout id="components-layout-demo-custom-trigger">
      <dash-sidebar
        defaultSelectedKeys="2"
        :menuItems="commonMenuItems.courseSubmitters"
        v-if="userRoleGetter === 'telas_course_submitters'"/>
        <dash-sidebar
        defaultSelectedKeys="1"
        :menuItems="commonMenuItems.admin"
        v-else-if="userRoleGetter === 'telas_telas_administrator'"/>
      <a-layout>
        <a-layout-content
          :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }">
          <a-card
          :bordered="false"
          style="width: 100%"
          >
            <a-alert
              v-if="successMessage"
              type="success"
              :message="successMessage"
              banner/>
              <br />
            <template class="ant-card-actions" slot="actions" v-if="userRoleGetter === 'telas_telas_administrator'">
              <router-link :to="{ 'name': 'edit-profile', params: { userID: userId } }"><a-icon :style="{ fontSize: '26px' }" type="edit" theme="twoTone" twoToneColor="#52c41a"/></router-link>
            </template>
            <a-card title="First Name" :style="{ marginTop: '16px' }" :hoverable="true" :loading="true">
              <div slot="extra">{{ userProfile.first_name }}</div>
            </a-card>
            <a-card title="Last Name" :style="{ marginTop: '16px' }" :hoverable="true" :loading="true">
              <div slot="extra">{{userProfile.last_name}}</div>
            </a-card>
            <a-card title="Email" :style="{ marginTop: '16px' }" :hoverable="true" :loading="true">
              <div slot="extra">{{userProfile.user_email}}</div>
            </a-card>
            <a-card title="Position" :style="{ marginTop: '16px' }" :hoverable="true" :loading ="true">
              <div slot="extra">{{userProfile.position}}</div>
            </a-card>
            <a-card title="Faculty" :style="{ marginTop: '16px' }" :hoverable="true" :loading="true">
              <div slot="extra">{{userProfile.faculty}}</div>
            </a-card>
            <a-card title="Institution Name" :style="{ marginTop: '16px' }" :hoverable="true" :loading ="true">
              <div slot="extra">{{userProfile.institution_name}}</div>
            </a-card>
            <a-card title="Institution Campus" :style="{ marginTop: '16px' }" :hoverable="true" :loading ="true">
              <div slot="extra">{{userProfile.institution_campus}}</div>
            </a-card>
            <a-card title="Institution state" :style="{ marginTop: '16px' }" :hoverable="true" :loading="true">
              <div slot="extra">{{userProfile.institution_state}}</div>
            </a-card>
            <a-card title="Institution Country" :style="{ marginTop: '16px' }" :hoverable="true" :loading="true">
              <div slot="extra">{{userProfile.institution_country}}</div>
            </a-card>
            <a-card title="Role" :style="{ marginTop: '16px', textTransform: 'capitalize' }"  :hoverable="true" :loading="true">
              <div slot="extra">{{userRole}}</div>
            </a-card>
          </a-card>
          <a-card :style="{ marginTop: '16px' }"
          v-if="userDetails.user_role === 'telas_telas_administrator'
          && userProfile.activated_by_admin === 'no'">
            <a-button
              id="approve-user-button"
              type="default" icon="check" @click="handleProfileActivation('approve')">
              Approve
            </a-button>
            <a-button
              id="decline-user-button"
              type="danger" icon="cross" @click="handleProfileActivation('decline');">
              Decline
            </a-button>
          </a-card>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import dashHeader from './Header.vue';
import dashSidebar from './Sidebar.vue';

export default {
  name: 'user-profile',
  components: {
    dashSidebar,
    dashHeader,
  },
  data() {
    return {
      userId: '',
      userRole: '',
      successMessage: false,
      breadCrumbsPages: [
        {
          name: 'Home',
          route: '/',
        },
        {
          name: 'Dashboard',
          route: '/dashboard',
        },
        {
          name: 'User Profile',
          route: `/user-profile/${this.$route.params.userId}`,
        },
      ],
    };
  },
  computed: {
    ...mapState('dashboard', {
      userProfile: state => state.userDetailsById,
    }),
    ...mapState('user', {
      userDetails: state => state.userDetails,
    }),
    ...mapGetters('user', {
      userToken: 'getUserToken',
    }),
    ...mapGetters('user', {
      userRoleGetter: 'getUserRole',
    }),
  },
  methods: {
    ...mapActions('dashboard', {
      getUserProfileByID: 'getUserProfileByID',
      userApproveAction: 'userApproveAction',
      deleteUser: 'deleteUser',
    }),
    handleProfileActivation(action) {
      if (action === 'approve') {
        this.userApproveAction({
          user_id: this.userId,
          action,
          userToken: this.userToken,
          user_role: this.userProfile.user_role,
        });
      } else {
        this.deleteUser({
          user_id: this.userId,
          force: true,
          reassign: 0,
          userToken: this.userToken,
        });
      }
    },
  },
  mounted() {
    this.userId = this.$route.params.userId;
    this.getUserProfileByID({ user_id: this.userId });
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'dashboard/GETUSERPROFILEBYID') {
        if (state.dashboard.userDetailsById.user_role.length > 0) {
          const userRoleStringArray = this.userProfile.user_role.split('_');
          userRoleStringArray.shift();
          this.userRole = userRoleStringArray.join(' ');
        }
      } else if (mutation.type === 'dashboard/USERACTION') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.successMessage = 'The user has been approved.';
      }
    });
  },
};
</script>
<style scoped>
 #approve-user-button:hover {
    border-color: #73d13d;
    background-color: #73d13d;
    color: #ffff;
  }
  #approve-user-button {
    color: #73d13d;
    float: right;
  }
  #decline-user-button {
    float: left;
  }
</style>
